import { render, staticRenderFns } from "./ModalTransferBase.vue?vue&type=template&id=1007d431"
import script from "./ModalTransferBase.vue?vue&type=script&lang=js"
export * from "./ModalTransferBase.vue?vue&type=script&lang=js"
import style0 from "./ModalTransferBase.vue?vue&type=style&index=0&id=1007d431&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports